import styled from '@emotion/styled';
import { theme } from '~/theme';

export const DeliveryAddressWrapper = styled.ul(() => ({
    width: '100%',
    listStyle: 'none',
    overflowY: 'auto',
}));

export const DeliveryWrapper = styled.li(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: theme.space[3],
    border: `1px solid ${theme.colors.brownLight}`,
    borderRadius: theme.sizes.cornerRadius,
    marginBottom: theme.space[3],
}));

export const ButtonAndPriceWrapper = styled.div(() => ({
    textAlign: 'right',
    paddingLeft: theme.space[2],
}));

export const CarrierNameAndArrivalWrapper = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
}));

export const CarrierTitle = styled.div(() => ({
    fontSize: theme.fontSizes.sm,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
    marginBottom: theme.space[2],
    marginTop: theme.space[2],
}));

export const ArrivalDetails = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
}));

export const PriceDetails = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    marginBottom: theme.space[2],
}));
